import {createApp, h} from 'vue';
import App from './App.vue';
import applyPlugins from "@/plugins";

import '@/styles/index.scss';

window.mountVueApp = (selector, options) => {
    const app = createApp({
        render() {
            return h(App, { options });
        }
    });

    applyPlugins(app);
    app.mount(selector);
}